<nav class="overflow-hidden" [class.collapsed]="menuService.menuSetCollapsed$ | async" [class.header]="!offcanvas">
  <app-icon-button icon="bi-list" (click)="toggleMenu()"></app-icon-button>
  <a class="logo" routerLink>
    <img src="assets/img/logo.svg" alt="Logo" />
  </a>
</nav>
